<template>
    <!-- Page Content Wrapper -->
    <div id="page-content-wrapper" class="admin-content-area">
        <div class="container-fluid xyz">
            <div class="page-header-top-container">
                <div class="page-name">Notifications</div>
            </div>
            <!--page content-->
            <div class="admin-page-content">

                <div class="fullblock">

                    <div class="row no-margin">

                        <!--Alert with different color-->
                        <div class="col-6">
                            <div class="notifications-top-block">
                                <span>Alert with different color</span>
                                <p>use the class alert alert-*colors* for dezier</p>
                            </div>

                            <div class="notifications-container">

                                <div class="notification-block">
                                    <b-alert variant="primary" show dismissible>
                                        This is an example top alert. You can edit what u wish. (primary)
                                    </b-alert>
                                </div>
                                
                                <div class="notification-block">
                                    <b-alert variant="secondary" show dismissible>
                                        This is an example top alert. You can edit what u wish. (secondary)
                                    </b-alert>
                                </div>

                                <div class="notification-block">
                                    <b-alert variant="success" show dismissible>
                                        This is an example top alert. You can edit what u wish. (success)
                                    </b-alert>
                                </div>

                                <div class="notification-block">
                                    <b-alert variant="info" show dismissible>
                                        This is an example top alert. You can edit what u wish. (Info)
                                    </b-alert>
                                </div>

                                <div class="notification-block">
                                    <b-alert variant="danger" show dismissible>
                                        This is an example top alert. You can edit what u wish. (danger)
                                    </b-alert>
                                </div>

                                <div class="notification-block">
                                    <b-alert variant="warning" show dismissible>
                                        This is an example top alert. You can edit what u wish. (warning)
                                    </b-alert>
                                </div>
                                
                                <div class="notification-block">
                                    <b-alert variant="light" show dismissible>
                                        This is an example top alert. You can edit what u wish. (light)
                                    </b-alert>
                                </div>

                                <div class="notification-block">
                                    <b-alert variant="dark" show dismissible>
                                        This is an example top alert. You can edit what u wish. (dark)
                                    </b-alert>
                                </div>


                            </div>
                        </div>
                        <!--Alert with different color-->

                        <!--Alert with different color-->
                        <div class="col-6">
                            <div class="notifications-top-block">
                                <span>Alert with image / icon</span>
                                <p>add the image / icon before content`</p>
                            </div>

                            <div class="notifications-container">

                                <div class="notification-block">
                                    <b-alert show dismissible>
                                        This is an example top alert. You can edit what u wish.
                                    </b-alert>
                                </div>

                                <div class="notification-block">
                                    <b-alert show dismissible>
                                        This is an example top alert. You can edit what u wish.
                                    </b-alert>
                                </div>

                                <div class="notification-block">
                                    <b-alert show dismissible>
                                        This is an example top alert. You can edit what u wish.
                                    </b-alert>
                                </div>

                                <div class="notification-block">
                                    <b-alert show dismissible>
                                        This is an example top alert. You can edit what u wish.
                                    </b-alert>
                                </div>


                            </div>
                        </div>
                        <!--Alert with different color-->

                    </div>

                </div>

            </div>
            <!--page content-->
        </div>
        <app-backend-footer></app-backend-footer>
    </div>
    <!-- Page Content Wrapper -->
</template>
<script>
    import Vue from 'vue';
    import BackendFooter from '@/components/backend/partials/footer';

    import { Alert } from 'bootstrap-vue/es/components';
    export default {
        name: 'Center',
        components: {
            'app-backend-footer': BackendFooter,

        },
        data() {
            return {
                dismissSecs: 10,
                dismissCountDown: 0,
                showDismissibleAlert: false
            }

        },
        beforeMount: function () {

        },
        mounted: function () {

        },
        methods: {
            countDownChanged(dismissCountDown) {
                this.dismissCountDown = dismissCountDown
            },
            showAlert() {
                this.dismissCountDown = this.dismissSecs
            }
        }
    }
</script>




// WEBPACK FOOTER //
// src/components/notifications.vue